import { createActions } from 'redux-actions';

export const {
  getAllFilters,
  getAllFiltersSuccess,
  getAllFiltersFailure,
  getProfileFilters,
  getProfileFiltersSuccess,
  getProfileFiltersFailure,
  setProfileFilter,
  updateProfileFilters,
  updateProfileFiltersSuccess,
  updateProfileFiltersFailure,
  resetProfileFilters,
  clearProfileFilters,
} = createActions(
  'GET_ALL_FILTERS',
  'GET_ALL_FILTERS_SUCCESS',
  'GET_ALL_FILTERS_FAILURE',
  'GET_PROFILE_FILTERS',
  'GET_PROFILE_FILTERS_SUCCESS',
  'GET_PROFILE_FILTERS_FAILURE',
  'SET_PROFILE_FILTER',
  'UPDATE_PROFILE_FILTERS',
  'UPDATE_PROFILE_FILTERS_SUCCESS',
  'UPDATE_PROFILE_FILTERS_FAILURE',
  'RESET_PROFILE_FILTERS',
  'CLEAR_PROFILE_FILTERS'
);
